import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/live_stream.jpg'


const _hoisted_1 = { class: "live_stream_container" }
const _hoisted_2 = {
  key: 0,
  class: "list_wrapper"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "item_img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "img",
  src: _imports_0
}
const _hoisted_7 = { class: "item_content" }
const _hoisted_8 = { class: "content_title" }
const _hoisted_9 = { class: "content_author" }
const _hoisted_10 = { class: "content_time" }
const _hoisted_11 = {
  key: 0,
  class: "item_btn"
}
const _hoisted_12 = {
  key: 1,
  class: "item_btn item_btn1"
}
const _hoisted_13 = {
  key: 2,
  class: "item_btn item_btn2"
}
const _hoisted_14 = {
  key: 1,
  class: "list_wrapper1"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "item_img" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "img",
  src: _imports_0
}
const _hoisted_19 = { class: "item_content" }
const _hoisted_20 = { class: "content_title" }
const _hoisted_21 = { class: "content_author" }
const _hoisted_22 = { class: "content_author content_author1" }

import { computed } from 'vue'
import CardTitle from './CardTitle.vue'
import { useThemeColor } from '@/utils/theme'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useRouter } from 'vue-router'
import { Record } from '@/api/Models/LiveRoomList'
import { getLivestreamRedirect } from '@/api/requests/LiveStream'
import { showToast } from 'vant'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'LiveStream',
  props: {
    data: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "7d372d6e": (_unref(themeColor))
}))

const props = __props

const themeColor = useThemeColor()
const { t } = useI18n()
const router = useRouter()

// 直播/回放/回放生成中
const watchLiveStream = async (item: Record) => {
  const isPlayback = item.status === 3 && item.coursewareId
  const isPlaybackGenerating = item.status === 3 && !item.coursewareId
  const isLiveStream = item.status === 1 || item.status === 2
  if (isLiveStream) {
    router.push({ name: 'live', query: { watchUrl: item.watchUrl } })
  }
  try {
    const res = await getLivestreamRedirect({
      id: item.id,
      type: 0
    })
    if (res) {
      if (isPlayback) {
        if (item.isAllowPlayback === 1) {
          // 回放状态 跳转课件
          router.push({
            name: 'courseDetail',
            query: {
              id: item.coursewareId,
              courseType: 'courseWare',
              channel: 5,
              title: item.name
            }
          })
          return
        }
      }
      if (isPlaybackGenerating) {
        if (item.isAllowPlayback === 1) {
          showToast(t('app_live_stream_replay_generation'))
          return
        }
        if (item.isAllowPlayback === 0) {
          return
        }
      }
    } else {
      // 你还没有该直播间的访问权限，请向管理员申请
      showToast(t('app_no_live_stream_permission'))
      router.replace({ path: '/empty', query: { msg: t('app_no_live_stream_permission') } })
    }
  } catch (error) {
    console.log(error, 'error')
  }
}
const clickHandle = (item: Record) => {
  watchLiveStream(item)
}

const listData = computed(() => {
  try {
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})
const type = computed(() => {
  try {
    return JSON.parse(props.data.extendInfo).layoutType
  } catch (error) {
    return 1
  }
})
const isSmallList = computed(() => type.value === 1)
const isBigList = computed(() => type.value === 2)
const isGridList = computed(() => type.value === 3)

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CardTitle, {
      title: _ctx.data.title,
      skipPage: "/liveStream"
    }, null, 8, ["title"]),
    (isSmallList.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "list_item",
              onClick: ($event: any) => (watchLiveStream(item))
            }, [
              _createElementVNode("div", _hoisted_4, [
                (item.coverFileUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "img",
                      src: item.coverFileUrl
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("img", _hoisted_6))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(item.name), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(item.lecturerName), 1),
                _createElementVNode("p", _hoisted_10, _toDisplayString(item.startTime), 1)
              ]),
              (item.status === 1 || item.status === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('app_live_stream_watch')), 1))
                : _createCommentVNode("", true),
              (item.status === 3 && item.isAllowPlayback === 1 && item.coursewareId)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('app_live_stream_playback')), 1))
                : _createCommentVNode("", true),
              (item.status === 3 && !item.coursewareId)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('app_live_stream_playback')), 1))
                : _createCommentVNode("", true)
            ], 8, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (isBigList.value || isGridList.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["list_item", { full: isBigList.value }]),
              key: item.id,
              onClick: ($event: any) => (clickHandle(item))
            }, [
              _createElementVNode("div", _hoisted_16, [
                (item.coverFileUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "img",
                      src: item.coverFileUrl
                    }, null, 8, _hoisted_17))
                  : (_openBlock(), _createElementBlock("img", _hoisted_18))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("p", _hoisted_20, _toDisplayString(item.name), 1),
                _createElementVNode("p", _hoisted_21, _toDisplayString(item.lecturerName), 1),
                _createElementVNode("p", _hoisted_22, _toDisplayString(item.startTime), 1)
              ])
            ], 10, _hoisted_15))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, listData.value && listData.value.length > 0]
  ])
}
}

})